import Vuex from "vuex";

export const store = new Vuex.Store({
  state: {
    token: null,
    userID: null,
    Classes: [],
    Sections: [],
    Subjects: [],
    ExamTypes: [],
    Profile:{}
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUserID(state, userID) {
      state.userID = userID;
    },
    setClasses(state, Classes) {
      state.Classes = [...new Set(Classes)];
    },
    setSections(state, Sections) {
      state.Sections = [...new Set(Sections)];
    },
    setExamTypes(state, ExamTypes) {
      state.ExamTypes = [...new Set(ExamTypes)];
    },
     setSubjects(state, Subjects) {
      state.Subjects = [...new Set(Subjects)];
    },
    setProfile(state, Profile) {
      state.Profile = Profile;
    },
   
    clearToken(state) {
      state.token = null;
    },
  },
  actions: {},
  getters: {},
});
export default store;
